
@if (urlVideos?.length > 0) {
  <div class="flex mb-4" >
    @for (level of urlVideos; track level; let i = $index) {
      @if (urlVideos.length > 1) {
        <span
        [class]="
          i == currentVideo
            ? 'w-[70px] h-2 rounded-lg bg-k-blue mr-2'
            : 'w-[70px] h-2 rounded-lg bg-[#7e98d4] mr-2'
        "
        ></span>
      }
    }
  </div>
}
<section>
  <div class="mb-[42px] text-lg text-[#53565b] flex items-start flex-col">
    <p class="sm:mb-[8px] text-lg text-[#53565b] leading-5">
      {{ heading.heading }}
    </p>
    <p class="text-sm m-0 text-k-black">
      {{ heading.heading1 }}
    </p>
  </div>
  <div>


    @for (video of videos; track video; let i = $index) {
      <div class="w-full" >
        @if (i == currentVideo) {
          <div
            class="w-full h-[386px] rounded-2xl"
          [class]="video.url">&nbsp;</div>
        }
      </div>
    }
  </div>

  <!-- To Refactoring and move it in the child component widget -->
  <mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>

  <div class="flex items-start justify-between pl-0 pr-0 w-full h-[65px] mt-4">
    <button  class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="handleSteps('backward')">
      @if (data.name == 'New Concepts') {
        <span class="flex items-center gap-2 text-[#18191C]"
          ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
          >
        }
      </button>
      <div
        class="w-[158px]"
        >
        <button
          type="submit"
          (click)="handleSteps('forward')"
          class="app__btn--primary mt-0"
          >
          Continue
        </button>
      </div>
    </div>

  </section>
